export default {"src":"/_next/static/media/pull-credit-bg.22b8ef14.svg","height":189,"width":302,"blurWidth":0,"blurHeight":0};